











import { EVENTS } from '@empathybroker/ebx-gluon';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class CdlCloseSortDropdown extends Vue {
  private closeDropdown() {
    this.$x.emit(EVENTS.SortToggleClicked);
  }
}
